import React from 'react';
import { Section, CtaButton } from './ui';
export const Offer = () => {
  return <Section id="checkout" className="bg-brand-premium text-white relative overflow-hidden" data-id="element-110">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-111"></div>

      <div className="relative z-10 max-w-3xl mx-auto bg-white/10 backdrop-blur-sm border border-white/20 rounded-3xl p-5 sm:p-8 md:p-12 shadow-2xl" data-id="element-112">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-semibold text-center mb-5" data-id="element-113">
          ¿Por qué tan barato?
        </h2>

        <div className="text-base md:text-xl text-center space-y-5 mb-8" data-id="element-114">
          <p data-id="element-115">
            Porque quiero que pruebes el método. Quiero que vivas ese momento en
            el que alguien prueba tu pastel y pregunta:
          </p>
          <p className="text-xl sm:text-2xl md:text-3xl font-serif italic font-semibold text-yellow-400 leading-snug" data-id="element-116">
            👉 “¿Seguro que esto es sin gluten?”
          </p>
        </div>

        <div className="bg-white rounded-2xl p-5 sm:p-8 text-center text-brand-dark shadow-xl mb-6" data-id="element-117">
          <div className="space-y-2 mb-6" data-id="element-118">
            <p className="text-sm sm:text-base text-gray-500 font-medium" data-id="element-119">
              Valor real total:{' '}
              <span className="line-through decoration-red-500" data-id="element-120">
                $154.000 ARS
              </span>
            </p>
            <p className="text-base sm:text-lg text-gray-600 font-medium" data-id="element-121">
              Precio normal del e-book:{' '}
              <span className="line-through decoration-red-500" data-id="element-122">
                $27.000 ARS
              </span>
            </p>
          </div>

          <div className="mb-6" data-id="element-123">
            <p className="text-base sm:text-xl font-bold text-brand-red uppercase tracking-wider mb-2" data-id="element-124">
              Hoy pagas solo:
            </p>
            <p className="text-5xl sm:text-6xl md:text-7xl font-bold text-brand-dark tracking-tight" data-id="element-125">
              $9.990{' '}
              <span className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-400" data-id="element-126">
                ARS
              </span>
            </p>
          </div>

          <p className="text-sm sm:text-base text-gray-600 font-medium mb-6" data-id="element-127">
            Pago único. Acceso inmediato. Sin suscripciones.
          </p>

          <CtaButton className="w-full" data-id="element-128" />

          <p className="text-xs sm:text-sm font-bold text-brand-red mt-4 uppercase tracking-widest" data-id="element-129">
            Oferta por tiempo limitado
          </p>
        </div>
      </div>
    </Section>;
};